import type { Prototype } from "../prototype-types";

export const abigailWaterstonPrototypes: Prototype[] = [
  {
    id: "fd-invite-as-automation",
    name: "FD invite as automation",
    path: "/aw/fd-invite-as-automation",
    description:
      "Lead capture CSV flow from Brand Portal Customers: mocked successful bulk upload (42 on-Faire, 66 off-Faire).",
    owner: "Abigail Waterston",
    createdAt: "2026-04-01",
    lastUpdated: "2026-04-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6ab33e7fbb789bd5f7963b7524fbdf601b8d40bbaa252498971a1006eccde0d3.png",
    creationTool: "cursor",
  },
  {
    id: "aw-create-conversation-entrypoint",
    name: "Create conversation entrypoint",
    path: "/aw/create-conversation-entrypoint",
    description: "",
    owner: "Abigail Waterston",
    createdAt: "2026-11-02",
    lastUpdated: "2026-11-02",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4a03950904a8797bb9975463667f6d89fe41b0a9662558a7c10d6bcc951debf2.png",
  },
];
